// extracted by mini-css-extract-plugin
export default {"base":"ManagementPage_base__i-qkl"};